import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button, Input, Label, Header } from 'semantic-ui-react';
import { isValidExternalDomain } from './ExternalDomainInputForm.utils';
import './ExternalDomainInputForm.css';
var defaultProps = {};
export default function ExternalDomainInputForm(_ref) {
  var onSelect = _ref.onSelect,
      onChangeDomainType = _ref.onChangeDomainType;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      externalDomain = _useState2[0],
      setExternalDomain = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      externalDomainInputError = _useState4[0],
      setExternalDomainInputError = _useState4[1];

  function onExternalDomainChange(e, _ref2) {
    var value = _ref2.value;

    if (externalDomainInputError && isValidExternalDomain(value)) {
      setExternalDomainInputError(false);
    }

    setExternalDomain(value);
  }

  function onSelectInternal() {
    if (!isValidExternalDomain(externalDomain)) {
      setExternalDomainInputError(true);
      return;
    }

    onSelect(externalDomain);
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    as: "h2",
    className: "day-smart-domain-select-header"
  }, "Enter Your Domain"), /*#__PURE__*/React.createElement(Input, {
    className: "domain-search-input domain-search-input-full-width custom-domain-input",
    type: "text",
    placeholder: "mydomain.com",
    action: true,
    labelPosition: "left",
    value: externalDomain,
    onChange: onExternalDomainChange
  }, /*#__PURE__*/React.createElement(Label, {
    className: "https-label domain-search-input-consistent-padding"
  }, "https://"), /*#__PURE__*/React.createElement("input", {
    className: "borderless-input domain-search-input-consistent-padding"
  }), /*#__PURE__*/React.createElement(Button, {
    id: "domain-connect-button",
    className: "domain-search-button centered-button",
    type: "submit",
    onClick: onSelectInternal
  }, "Connect")), externalDomainInputError && /*#__PURE__*/React.createElement("p", {
    className: "error-message"
  }, "Please enter a valid domain."), /*#__PURE__*/React.createElement("p", {
    className: "modal-subheader body-text blue-color"
  }, "Once you've completed the sign up process you'll receive an email with instructions on how to provide us with access to your domain to connect the website."), /*#__PURE__*/React.createElement(Button, {
    id: "custom-domain-connect-button",
    className: "publish-now-from-request-button extra-margin centered-content blue-color",
    onClick: onChangeDomainType
  }, "I want to search for a new domain."));
}
ExternalDomainInputForm.defaultProps = defaultProps;